export default "__VITE_ASSET__BKA3VJrQ__"